import React, { useEffect } from "react"
import { Helmet, HelmetProvider } from "react-helmet-async"
import AOS from "aos"
import "aos/dist/aos.css"
import { BrowserRouter } from "react-router-dom"
import AppRouter from "./router/AppRouter.jsx"
import ScrollToTop from "./components/ScrollToTop"
import { SnackbarProvider } from "notistack"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import { Box } from "@mui/material"
import { Provider } from "react-redux"
import store from "./redux/store"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { initializeStoreHydration } from "./redux/hydration/storeHydration"
import { usePageTracking } from "./hooks/usePageTracking"

const queryClient = new QueryClient()

const theme = createTheme({})

// Analytics wrapper component
function AnalyticsWrapper({ children }) {
  usePageTracking() // This will track page views automatically
  return children
}

function App() {
  useEffect(() => {
    document.title = "Ryan Dymock website"
  }, [])

  useEffect(() => {
    AOS.init({
      duration: 1200,
    })
  }, [])

  // Initialize Firestore-Redux integration
  useEffect(() => {
    initializeStoreHydration(store)
  }, [])

  return (
    <HelmetProvider>
      <Box sx={{ height: "100vh" }}>
        <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="Data Science, Analytics, Data, sass, software company"
        />
        <meta name="description" content="ryandymock.com" />
        <meta property="og:site_name" content="RyanDymock" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Ryan Dymock personal website" />
        </Helmet>
        {/* {End Seo Helmet}
         */}
        <ScrollToTop />
        <BrowserRouter>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
              <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <AnalyticsWrapper>
                  <AppRouter />
                </AnalyticsWrapper>
              </SnackbarProvider>
            </QueryClientProvider>
          </ThemeProvider>
        </Provider>
        </BrowserRouter>
      </Box>
    </HelmetProvider>
  )
}

export default App
